import React from "react";
import styled from "styled-components";

export default function HandelsbetingelserPage() {
  return (
    <HandelsWrapper>
      <h1>Handelsbetingelser</h1>

      <section>
        <h2>1. Generelle oplysninger</h2>
        <p>
          <strong>Restaurant:</strong> Atapizza
        </p>
        <p>
          <strong>Adresse:</strong> Enghavevej 28A, 1674 København V
        </p>
        <p>
          <strong>Telefon:</strong> 33 24 83 00
        </p>
        <p>
          <strong>Hjemmeside:</strong> atapizza.dk
        </p>
      </section>

      <section>
        <h2>2. Bestilling</h2>
        <p>
          Bestilling foretages via atapizza.dk ved at vælge ønskede madretter,
          lægge dem i kurven og udfylde bestillingsformularen.
        </p>
        <p>
          Vi indsamler kun nødvendige oplysninger: navn, telefonnummer,
          e-mailadresse og eventuelle kommentarer.
        </p>
        <p>
          Der foretages <strong>ingen online betaling</strong>. Betaling sker
          ved afhentning eller levering.
        </p>
      </section>

      <section>
        <h2>3. Bindende bestilling</h2>
        <p>
          Når bestillingen er sendt, er den bindende. Atapizza kan kontakte
          kunden ved spørgsmål eller uklarheder.
        </p>
      </section>

      <section>
        <h2>4. Priser</h2>
        <p>
          Alle priser er angivet i DKK inkl. moms. Der tages forbehold for
          prisændringer og tastefejl.
        </p>
      </section>

      <section>
        <h2>5. Afhentning og levering</h2>
        <p>
          Tidspunkt aftales ved bestilling. Forsinkelser uden for vores kontrol
          kan forekomme.
        </p>
      </section>

      <section>
        <h2>6. Fortrydelsesret</h2>
        <p>
          Der ydes ingen fortrydelsesret på fødevarer, der fremstilles efter
          kundens valg.
        </p>
      </section>

      <section>
        <h2>7. Persondata (GDPR)</h2>
        <p>Personoplysninger behandles i overensstemmelse med GDPR.</p>
        <p>
          Oplysninger anvendes udelukkende til håndtering af bestillingen og
          videregives ikke til tredjepart.
        </p>
        <p>
          Data opbevares sikkert og slettes, når de ikke længere er nødvendige.
        </p>
      </section>

      <section>
        <h2>8. Ansvarsbegrænsning</h2>
        <p>
          Atapizza kan ikke holdes ansvarlig for indirekte tab eller tekniske
          fejl på hjemmesiden.
        </p>
      </section>

      <section>
        <h2>9. Klager</h2>
        <p>Klager bedes rettet direkte til restauranten via telefon.</p>
      </section>

      <section>
        <h2>10. Ændringer</h2>
        <p>
          Handelsbetingelserne kan løbende opdateres. Den gældende version
          findes altid på hjemmesiden.
        </p>
      </section>
    </HandelsWrapper>
  );
}

/* ===============================
   Styled Components (nederst)
   =============================== */

const HandelsWrapper = styled.section`
  max-width: 900px;
  margin: 0 auto;
  padding: 20px 16px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  color: #222;

  h1 {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  section {
    margin-bottom: 1.6rem;
  }

  h2 {
    font-size: 1.15rem;
    margin-bottom: 0.4rem;
    color: #111;
  }

  p {
    font-size: 0.95rem;
    line-height: 1.6;
    margin: 0.2rem 0;
  }

  strong {
    font-weight: 600;
  }

  @media (max-width: 600px) {
    padding: 16px 12px;

    h1 {
      font-size: 1.5rem;
    }

    h2 {
      font-size: 1.05rem;
    }

    p {
      font-size: 0.92rem;
    }
  }
`;
